import openSocket from 'socket.io-client';

import notifSystem from './notifSystem';
import SocketV2Client from './socket-v2-client';
import listCollections, { chatCollections } from './constants/listCollections';
import { setCount } from './cache';
import store from './store';
import { userConnect } from './actions/users';

class Ws {
  login(user) {
    this.socket = openSocket({
      transports: ['websocket'],
      // Étale les reconnexions spontanées sur une fenêtre plus large
      // (au lieu du défaut ~1-2s) pour éviter qu'un redémarrage serveur ne
      // fasse reconnecter tous les clients en même temps (voir incident 500
      // du 2026-08-20). Le délai de reconnexion après un arrêt planifié du
      // serveur est lui-même piloté par l'évènement 'server:shutdown'.
      reconnectionDelay: 2000,
      reconnectionDelayMax: 20000,
      randomizationFactor: 0.5,
    });
    this.socket.on('server:shutdown', ({ retryAfter }) => {
      this.socket.io.reconnectionDelay(retryAfter);
      this.socket.io.reconnectionDelayMax(retryAfter);
    });
    if (this.socketV2) {
      this.socketV2.reconnect(user.token);
    } else {
      this.socketV2 = new SocketV2Client('/v2');
      this.socketV2.connect(window.location.origin, user.token);
    }
    this.resetLock();
    this.socket.on('logged', () => {
      this.isLogged = true;
      this.unlock();
    });
    this.socket.on('error', this.printError);
    this.socket.on('disconnect', (e) => {
      this.resetLock();
      this.disconnect(e, user);
    });
    this.socket.on('notif', notifSystem.send);
    this.socket.on('connect', () => {
      this.connect(user);
      store.dispatch(userConnect(true));
    });
  }

  // Un verrou encore en attente est gardé : des send() l'attendent déjà.
  resetLock() {
    if (!this.lock || this.isLogged) {
      this.isLogged = false;
      this.lock = new Promise((res) => {
        this.unlock = res;
      });
    }
  }

  printError(err) {
    notifSystem.error(err.name, err.message);
    store.dispatch(userConnect(false));
  }

  connect(user) {
    if (window.name === 'chat') {
      chatCollections.forEach(e => {
        this.send(e);
      });
      return;
    }
    setTimeout(() => {
      if (this.socket) {
        this.socket.emit('login', user);
        listCollections.forEach((e) => {
        // to join room collection
          this.send(e);
          this.socket.on(`count_${e}`, (data) => {
            const key = Object.keys(data)[0];
            setCount(key, data[key]);
          });
        });
      }
    }, 5000);
  }

  disconnect(e, user) {
    setTimeout(() => {
      if (e === 'io server disconnect') {
        this.login(user);
      } else if (!this.socket) {
        this.disconnect(e, user);
      } else {
        this.socket.connect();
        // Re-establish v2 after v1 auto-reconnects
        if (this.socketV2 && user) {
          this.socketV2.reconnect(user.token);
        }
      }
    }, 5000);
    store.dispatch(userConnect(false));
  }

  logout(user) {
    if (this.socketV2) {
      this.socketV2.disconnect();
      this.socketV2 = null;
    }
    if (this.socket) {
      if (user) {
        this.socket.emit('idle', user, true);
      }
      listCollections.forEach((e) => this.socket.send(`exit_${e}`));
      this.socket.removeAllListeners();
      this.socket.close();
      this.socket = undefined;
    }
    store.dispatch(userConnect(false));
  }

  async send(...args) {
    await this.lock;
    if (this.socket) {
      this.socket.emit(...args);
    }
  }

  on(...args) {
    return this.socket.on(...args);
  }

  once(...args) {
    return this.socket.once(...args);
  }

  removeEventListener(...args) {
    if (this.socket) {
      return this.socket.removeListener(...args);
    }
    return undefined;
  }
}

export default new Ws();
